export default __webpack_public_path__ + "static/screenshot-timeseries-chart-cc447bd00b92d49fe14607d3b08d1889.png";